import "./globalPolyfill";
import "whatwg-fetch";

export default (url, method, body) => {
    const options = {
        method,
        headers: requestHeaders(),
        body: method !== "GET" ? JSON.stringify(body) : null
    };

    return fetch(url, options).then(
        res =>
            new Promise((resolve, reject) => {
                const status = res.status;
                if (status >= 200 && status < 300) {
                    res.json()
                        .then(response => resolve(response))
                        .catch(error => reject(error));
                } else {
                    reject("Unknown Error");
                }
            })
    );
};

function requestHeaders() {
    return {
        Accept: "application/json",
        "Content-Type": "application/json"
    };
}



// WEBPACK FOOTER //
// ./util/fetch.js